<template>
  <div>
    <el-form
      ref="form"
      :model="formData"
      :rules="rules"
      size="medium"
      inline-message
    >
      <el-row :gutter="20">
        <el-col :span="8">
          <el-form-item
            :label="$l('INDEX.order_doc_orderDocFileType') || '订单文档类型'"
            prop="orderTechDocFileType"
          >
            <dict-select
              v-model="formData.orderTechDocFileType"
              size="medium"
              url="/master/common/dict/biz"
              :placeholder="
                $l('INDEX.form_ple_order_doc_orderDocFileType') || '请选择文档类型'
              "
              style="width: 100%"
              filterable
              clearable
              :selectedLabel.sync="formData.orderTechDocFileName"
              :body="orderTechDocFileTypeParams"
            ></dict-select>
          </el-form-item>
        </el-col>
        <el-col :span="16">
          <el-form-item :label="$l('INDEX.order_doc_remark') || '备注说明'">
            <el-input
              v-model="formData.remark"
              :placeholder="$l('INDEX.form_ple_order_doc_remark') || '请输入备注说明'"
              clearable
              maxlength="250"
              show-word-limit
            />
          </el-form-item>
        </el-col>
      </el-row>
    </el-form>
    <el-dialog
      append-to-body
      :title="$l('INDEX.tips_question_title') || '提示信息'"
      :visible.sync="backDialogVisible"
      width="30%"
    >
      <span>{{ $l('INDEX.tips_question_save') || '是否要保存更改' }}</span>
      <span slot="footer" class="dialog-footer">
        <el-button @click="backDialogVisible = false" size="small">{{
          $l('INDEX.btn_cancel') || '取消'
        }}</el-button>
        <el-button @click="close()" size="small">{{
          $l('INDEX.btn_no_save') || '不保存'
        }}</el-button>
        <el-button @click="save()" type="primary" size="small">{{
          $l('INDEX.btn_save') || '保存'
        }}</el-button>
      </span>
    </el-dialog>
  </div>
</template>
<script>
import validate from '@/libs/util.validate'
import EditLoading from '@/mixins/edit-loading'
export default {
  mixins: [EditLoading],
  props: {
    changeOrderCode: { type: String, default: '' },
    data: { type: Object, default: () => {} },
  },
  watch: {
    data: {
      handler() {
        this.formData = { ...this.data }
      },
      immediate: true,
    },
  },
  data() {
    return {
      orderTechDocFileTypeParams: { dictType: 'orderTechDocFileType' },
      formData: {},
      rules: {
        orderTechDocFileType: [
          {
            required: true,
            message:
              this.$l('INDEX.form_ple_order_doc_orderDocFileType') ||
              '请选择文档类型',
            trigger: 'change',
          },
        ],
      },
      backDialogVisible: false,
    }
  },
  methods: {
    async getForm() {
      const result = await validate.formValidate([this.$refs.form])
      if (!result) return (this.backDialogVisible = false)
      const params = {
        ...this.formData,
      }
      return params
    },
    cancel() {
      this.backDialogVisible = true
    },
    close() {
      this.backDialogVisible = false
      this.$emit('close')
    },
    save() {
      this.$emit('save')
    },
  },
}
</script>
